import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-apg-bar-graph',
  templateUrl: './apg-bar-graph.component.html',
  styleUrls: ['./apg-bar-graph.component.scss'],
})
export class ApgBarGraphComponent implements OnInit {
  @Input() startColor: string;
  @Input() endColor: string;
  @Input() lowValue: number;
  @Input() highValue: number;
  @Input() steps: number;
  @Input() label: string;

  data: any[];

  view: any[] = [270, 200];
  xAxis = false;
  yAxis = false;
  showXAxisLabel = false;
  showYAxisLabel = false;
  gridLines = false;
  legend = false;
  gradient = false;
  yAxisLabel: string = '';
  xAxisLabel: string = '';
  barPadding: number = 2;
  colorScheme: any;
  
  constructor() { }

  ngOnInit() {
    this.data = this.generateBarData(this.lowValue, this.highValue, this.steps);
    this.colorScheme = {
      domain: this.generateColorGradient(this.startColor, this.endColor, this.steps),
    };

  }

  generateBarData(lowValue: number, highValue: number, steps: number) {
    const stepSize = (highValue - lowValue) / steps;
    return Array.from({ length: steps + 1 }, (_, index) => {
      const value = lowValue + index * stepSize;
      return { name: `Step ${index + 1}`, value: Math.round(value) };
    });
  }

  generateColorGradient(startColor: string, endColor: string, steps: number): string[] {
    const startRgb = hexToRgb(startColor);
    const endRgb = hexToRgb(endColor);
  
    const gradientColors: string[] = [];
  
    for (let i = 0; i <= steps; i++) {
      const r = Math.round(startRgb[0] + (endRgb[0] - startRgb[0]) * (i / steps));
      const g = Math.round(startRgb[1] + (endRgb[1] - startRgb[1]) * (i / steps));
      const b = Math.round(startRgb[2] + (endRgb[2] - startRgb[2]) * (i / steps));
  
      gradientColors.push(rgbToHex(r, g, b));
    }
  
    return gradientColors;
  }
  
}

function hexToRgb(hex: string): [number, number, number] {
  const bigint = parseInt(hex.slice(1), 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return [r, g, b];
}

function rgbToHex(r: number, g: number, b: number): string {
  const toHex = (value: number) => {
    const hex = value.toString(16);
    return hex.length === 1 ? '0' + hex : hex; 
  };
  
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`.toUpperCase();
}

